import React from "react";

import Icon2 from "../../assets/images/candlestick_chart.png";
import Icon1 from "../../assets/images/construction.png";
import Icon3 from "../../assets/images/engineering.png";
import Icon6 from "../../assets/images/science.png";
import Icon4 from "../../assets/images/science_off.png";
import Icon5 from "../../assets/images/view_in_ar.png";
import * as S from "./styles";

function Servicess() {
  return (
    <S.Service>
      <S.Word>Our Services</S.Word>
      <S.Title>Available for all your maintenance needs</S.Title>
      <S.CardServiceContainer>
        <S.CardService
          icon={Icon1}
          title="Installation services"
          description="Reliable, expert support for safe and efficient equipment installation during turnarounds and projects."
        />
        <S.CardService
          icon={Icon3}
          title="Plant inspections"
          description="Thorough inspections to detect issues early, reduce downtime, and ensure safe, reliable plant operation.."
        />
        <S.CardService
          icon={Icon4}
          title="Non-destructive testing"
          description="Advanced inspections to detect flaws early—minimizing downtime, risks, and environmental impact."
        />
        <S.CardService
          icon={Icon5}
          title="3D laser scanning"
          description="High-precision plant scans for accurate planning, retrofits, and real-time project visualization."
        />
        <S.CardService
          icon={Icon2}
          title="Emissions measurements"
          description="Accurate, on-site data to optimize performance, ensure compliance, and support environmental goals."
        />
        <S.CardService
          icon={Icon6}
          title="Laboratory testing"
          description="In house lab analyses to assess carbon efficiency, scrubber behavior, and gas treatment performance."
        />
      </S.CardServiceContainer>

      <S.HireButton>Hire us today</S.HireButton>
    </S.Service>
  );
}

export default Servicess;
